import api from '@/api/externalids'
import { mergeUserContext } from '@/store/helpers'

// initial state
const state = {
  personExternalIds: [],
  createExternalIdResponse: false
}

const getters = {
  personExternalIds: state => state.personExternalIds,
  createExternalIdResponse: state => state.createExternalIdResponse
}

const actions = {
  async getPersonExternalIds ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await api.getPersonExternalIds(payload)
    commit('SET_PERSON_EXTERNAL_IDS', response.body)
  },
  async createExternalId ({ commit, state, rootState }, payload) {
    payload = mergeUserContext(payload, rootState)
    const response = await api.createExternalId(payload)
    // if (response.success) {
    //   commit('SUCCESSFULLY_CREATED_EXTERNALID', response)
    // }
    if (response.ok) {
      commit('SUCCESSFULLY_CREATED_EXTERNALID', response.body)
    }
    commit('SET_CREATE_EXTERNAL_ID_RESPONSE', response)
  }
}

const mutations = {
  SET_PERSON_EXTERNAL_IDS (state, response) {
    state.personExternalIds = response
  },
  SET_CREATE_EXTERNAL_ID_RESPONSE (state, response) {
    state.createExternalIdResponse = response
  },
  RESET_PERSON_EXTERNAL_IDS (state, response) {
    state.personExternalIds = []
  },
  RESET_CREATE_EXTERNAL_ID_RESPONSE (state, response) {
    state.createExternalIdResponse = false
  },
  SUCCESSFULLY_CREATED_EXTERNALID (state, response) {
    state.personExternalIds.push(response)
  }
}

export default {
  state,
  getters,
  actions,
  mutations
}



// WEBPACK FOOTER //
// ./src/store/externalids.js